var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 30H3V39H9V30ZM24 18H18V39H24V18ZM39 3V39H33V3H39ZM33 0C32.2043 0 31.4413 0.31607 30.8787 0.87868C30.3161 1.44129 30 2.20435 30 3V39C30 39.7957 30.3161 40.5587 30.8787 41.1213C31.4413 41.6839 32.2043 42 33 42H39C39.7957 42 40.5587 41.6839 41.1213 41.1213C41.6839 40.5587 42 39.7957 42 39V3C42 2.20435 41.6839 1.44129 41.1213 0.87868C40.5587 0.31607 39.7957 0 39 0H33ZM15 18C15 17.2044 15.3161 16.4413 15.8787 15.8787C16.4413 15.3161 17.2044 15 18 15H24C24.7956 15 25.5587 15.3161 26.1213 15.8787C26.6839 16.4413 27 17.2044 27 18V39C27 39.7957 26.6839 40.5587 26.1213 41.1213C25.5587 41.6839 24.7956 42 24 42H18C17.2044 42 16.4413 41.6839 15.8787 41.1213C15.3161 40.5587 15 39.7957 15 39V18ZM0 30C0 29.2044 0.31607 28.4413 0.87868 27.8787C1.44129 27.3161 2.20435 27 3 27H9C9.79565 27 10.5587 27.3161 11.1213 27.8787C11.6839 28.4413 12 29.2044 12 30V39C12 39.7957 11.6839 40.5587 11.1213 41.1213C10.5587 41.6839 9.79565 42 9 42H3C2.20435 42 1.44129 41.6839 0.87868 41.1213C0.31607 40.5587 0 39.7957 0 39V30Z",
    fill: "#799AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanering);
export default __webpack_public_path__ + "static/media/Planering.c14000d1409faa8b15a2ceb0cd532746.svg";
export { ForwardRef as ReactComponent };